module.exports = __webpack_public_path__ + "static/media/x-23.f0b48707.png";